import { AvatarGroup, useTheme } from '@mui/material';

import { Avatar, Icon } from '@sbv-clients/ui-shared';

const AVATAR_SIZE = 32;

export const PrimaryAvatarGroup = ({ count }: { count: number }) => {
  const theme = useTheme();
  const primaryLight = theme.palette.primary.light;
  const primaryMain = theme.palette.primary.main;
  return (
    <AvatarGroup
      max={7}
      sx={{
        justifyContent: 'flex-start',
        '& .MuiAvatarGroup-avatar': {
          width: AVATAR_SIZE,
          height: AVATAR_SIZE,
          fontSize: 13,
        },
      }}
    >
      {Array.from({ length: count }).map((_, i) => (
        <Avatar
          key={i}
          sx={{ width: AVATAR_SIZE, height: AVATAR_SIZE }}
          style={{ background: primaryLight, color: primaryMain }}
        >
          <Icon name="Person" sx={{ color: 'primary.main' }} />
        </Avatar>
      ))}
    </AvatarGroup>
  );
};
